export const bFiltersStateArraySelector = (state) => state.appFilterAndSort.bFiltersStateArray;
export const nFiltersStateArraySelector = (state) => state.appFilterAndSort.nFiltersStateArray;
export const petFriendlySelectedSelector = (state) => state.appFilterAndSort.petFriendlySelected;
export const getRangeSliderMinValueSelector = (state) => state.appFilterAndSort.rangeSliderMin;
export const getRangeSliderMaxValueSelector = (state) => state.appFilterAndSort.rangeSliderMax;
export const resultsAppliedSortSelector = (state) => state.appFilterAndSort.resultsAppliedSort;

export const accomGetRangeSliderMinValueSelector = (state) => state.appFilterAndSort.accom.rangeSliderMin;
export const accomGetRangeSliderMaxValueSelector = (state) => state.appFilterAndSort.accom.rangeSliderMax;
export const accomGetAppliedSortSelector = (state) => state.appFilterAndSort.accom.appliedSort;
export const accomFiltersStateArraySelector = (state) => state.appFilterAndSort.accom.filtersStateArray;
export const accomBedroomsSelector = (state) => state.appFilterAndSort.accom.bedrooms;
export const accomBathroomsSelector = (state) => state.appFilterAndSort.accom.bathrooms;
export const accomPriceFiltersSelector = state => {
  const minPrice = state.appFilterAndSort.accom?.rangeSliderMin;
  const maxPrice = state.appFilterAndSort.accom?.rangeSliderMax;
  return [minPrice, maxPrice]
}